export default __webpack_public_path__ + "static/media/H264.5fcc7992.mp4";